import { render, staticRenderFns } from "./ServiceProviderService.vue?vue&type=template&id=4d791be2&"
import script from "./ServiceProviderService.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports